import Choices from "choices.js";

const Blog = () => {
  const filters = document.querySelector(".blog-filter");

  if (!filters) {
    return;
  }

  const tagToURL = (tag) => {
    if (tag == "__concern-") {
      return "";
    }
    return tag
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");
  };

  const updateSelectCounts = () => {
    const selects = document.querySelectorAll(".choices");

    selects.forEach((select) => {
      const inner = select.querySelector(".choices__inner");

      // ensure there is a count element within inner
      if (!inner.querySelector(".choices__count")) {
        const count = document.createElement("div");
        count.classList.add("choices__count");
        count.classList.add("hidden");
        inner.appendChild(count);
      }

      // count the number of is-selected items within select and update the count element
      const count = select.querySelector(".choices__count");
      const selected = select.querySelectorAll(".is-selected");

      if (selected.length > 0) {
        count.innerHTML = selected.length;
        count?.classList.remove("hidden");
      } else {
        count?.classList.add("hidden");
      }
    });
  };

  const updateBlogPosts = () => {
    updateSelectCounts();

    const tiles = document.querySelector(".blog-tiles");

    if (!tiles) {
      return;
    }

    const concerns = document.querySelector(".blog-filter--concerns select");

    // @ts-expect-error
    let concernHandle = concerns?.value ?? "";

    if (concernHandle === "stress--mood") {
      // concernHandle = "stress";
    }

    const filters = document.querySelector(".blog-filter--tags select");

    const tags = [
      tagToURL("__concern-" + concernHandle),
      tagToURL(filters?.value),
    ]
      .filter((el) => el)
      .join("+");

    const uri = tags ? `/blogs/news/tagged/${tags}` : `/blogs/news`;

    // push state to the browser history
    window.history.pushState({}, "", uri);

    tiles.classList.add("loading");
    tiles.innerHTML = "";

    // fetch the blog posts which have the tagged
    fetch(uri)
      .then((response) => response.text())
      .then((data) => {
        // parse the plain text data for the blog tiles and update the DOM
        const doc = new DOMParser().parseFromString(data, "text/html");
        const blogTiles = doc.querySelector(".blog-tiles");

        if (blogTiles) {
          tiles.classList.remove("loading");
          tiles.innerHTML = blogTiles.innerHTML;
        } else {
          tiles.classList.remove("loading");
          tiles.innerHTML =
            document.querySelector("#no-posts")?.innerHTML || "";
        }
      })
      .catch((error) => {
        console.error(error);
        tiles.classList.remove("loading");
        tiles.innerHTML = document.querySelector("#no-posts")?.innerHTML || "";
      });
  };

  function nicerChoices(element, selector, dropdown) {
    let isRemoving = false;

    element.addEventListener("addItem", function (event) {
      if (!isRemoving) {
        updateBlogPosts();
      }
    });

    element.addEventListener("removeItem", function (event) {
      updateBlogPosts();

      isRemoving = false;
    });

    element.addEventListener("choice", function (event) {
      isRemoving = true;
      // if the choice is already selected, remove it from the dropdown
      if (event.detail.choice.selected) {
        const value = event.detail.choice.value;

        setTimeout(() => {
          dropdown.removeActiveItemsByValue(value);
          updateBlogPosts();
          isRemoving = false;
          return false;
        }, 20);
      } else {
        isRemoving = false;
      }
    });

    const choiceLists = document.querySelectorAll(`${selector} .choices__list`);

    choiceLists.forEach((choiceList) => {
      choiceList.addEventListener("click", function (event) {
        // if the choice is open, close the dropdown
        if (dropdown.dropdown.isActive) {
          dropdown.hideDropdown(true);
        }
      });
    });

    updateSelectCounts();
  }

  // on load if we have already tagged posts then select those
  const preSelect = filters.dataset.selected;

  const element = document.querySelector(".blog-filter--tags select");

  if (element) {
    let tagChoices = new Choices(element, {
      searchEnabled: false,
      placeholderValue: "Filter by tag",
      itemSelectText: "",
      labelId: "tagFilter",
      renderSelectedChoices: "always",
    });

    nicerChoices(element, ".blog-filter--tags", tagChoices);

    if (preSelect) {
      preSelect.split(",").forEach((tag) => {
        tag = tag.replace("__concern-", "");
        if (
          document.querySelector(
            `.blog-filter--tags .choices__item[data-value="${tag}"]`
          )
        ) {
          tagChoices.setChoiceByValue(tag);
        }
      });
    }
  }

  const concerns = document.querySelector(".blog-filter--concerns select");

  if (concerns) {
    let concernChoices = new Choices(concerns, {
      searchEnabled: false,
      placeholderValue: "Filter by concern",
      labelId: "concernFilter",
      itemSelectText: "",
      renderSelectedChoices: "always",
    });

    nicerChoices(concerns, ".blog-filter--concerns", concernChoices);

    if (preSelect) {
      preSelect.split(",").forEach((tag) => {
        tag = tag.replace("__concern-", "");
        if (
          document.querySelector(
            `.blog-filter--concerns .choices__item[data-value="${tag}"]`
          )
        ) {
          concernChoices.setChoiceByValue(tag);
        }
      });
    }
  }
};

export default Blog;
